import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sofax/hero-circle.svg")